<template>
  <v-data-table :headers="headers" :items="contactLensTestLens" sort-by="text">
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Nova lente
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.name"
                      label="Nome"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <v-combobox
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.diopter"
                      label="Dioptria"
                      :items="sphericalValues"
                      :menu-props="{ auto: true, maxHeight: 304 }"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.radius"
                      label="Raio"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <v-combobox
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.spherical"
                      label="Grau esférico"
                      :items="sphericalValues"
                      :menu-props="{ auto: true, maxHeight: 304 }"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.diameter"
                      label="Diâmetro"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    <v-textarea
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.observation"
                      label="Observação"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_hma"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hma"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há lentes cadastradas
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "LensList",
    props: {
      contactLensGroup: Object,
    },
    data() {
      return {
        dialog: null,
        editedItem: {
          spherical: "Em branco",
          diopter: "Em branco",
        },
        defaultItem: {
          spherical: "Em branco",
          diopter: "Em branco",
        },
        editedIndex: -1,
        headers: [
          { text: "Name", value: "name" },
          { text: "Dioptria", value: "diopter" },
          { text: "Raio", value: "radius" },
          { text: "Grau esférico", value: "spherical" },
          { text: "Diâmetro", value: "diameter" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
        contactLensTestLens: [],
      };
    },
    mounted() {
      this.contactLensTestLens = [];
    },
    watch: {
      contactLensGroup() {
        this.contactLensTestLens = [];
      },
    },
    apollo: {
      contactLensTestLens: {
        query: require("@/graphql/contact_lens_test/lens.gql"),
        variables() {
          return {
            contactLensGroupId: this.contactLensGroup.id,
          };
        },
        pollInterval: 20000,
        skip() {
          return !this.contactLensGroup?.id;
        },
      },
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Nova lente" : "Editar lente";
      },
      sphericalValues() {
        let sphericalValues = [];

        for (let index = -30; index <= 30; index += 0.25) {
          let value = `${index.toFixed(2)}`;

          if (index >= 0) {
            value = `+${index.toFixed(2)}`;
          }

          sphericalValues.push(value.replace(".", ","));
        }

        sphericalValues.splice(sphericalValues.length / 2, 0, "Em branco");

        return sphericalValues;
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.contactLensTestLens.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse lente?")) {
          this.apolloMutate({
            mutation: require("@/graphql/contact_lens_test/delete_contact_len.gql"),
            variables: {
              contactLenId: item.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Lente deletada com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/save_contact_len.gql"),
          variables: {
            contactLenId: this.lodash.get(this.editedItem, "id", ""),
            contactLenGroupId: this.contactLensGroup.id,
            name: this.editedItem.name,
            spherical: this.editedItem.spherical,
            diopter: this.editedItem.diopter,
            radius: this.editedItem.radius,
            diameter: this.editedItem.diameter,
            observation: this.editedItem.observation,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      refreshList() {
        return this.$apollo.queries.contactLensTestLens.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
